import { assertHolidayProfilesConfig } from '../utils/holidayHoursProfile';

const localeConfigs = {
  au: {
    ecCountryCode: 'AU',
    locale: 'en-AU',
    currency: 'AUD',
    currencySymbol: '$', // See also: getCurrencySymbol in helpers
    centSymbol: '¢',
    minDiscount: 15,
    blockedRoutes: [],
    whiteLabelBlocked: false,
    opposBlocked: false,
    goalsBlocked: false,
    takeawayBlocked: false,
    loyaltyBlocked: false,
    partnerFaqUrl: 'https://eatclub.com.au/partners/faqs',
    supportPhone: '02 6190 8990',
    supportEmail: 'CS@eatclub.com.au',
    supportEmail2: 'hello@eatclub.com.au',
    trialSupportEmail: 'forecasting.support@eatclub.com.au',
    settlementGuide: 'https://eccdn.com.au/partnerportal/Settlement%20guide%20AU.pdf',
    welcomeGuide: 'https://eccdn.com.au/partnerportal/Welcome%20Guide%20AU.pdf',
    paymentProvider: 'stripe',
    eftposName: 'EFTPOS',
    taxCode: 'GST',
    taxIdentifierLabel: 'ABN',
    publicImagePath: 'https://eccdn.com.au/partnerportal/img/au',
    customerTermsUrl: 'https://eatclub.com.au/terms',
    ecBookingsTermsUrl: 'https://eatclub.com.au/partners/bookings-terms',
    privacyPolicyUrl: 'https://eatclub.com.au/privacy-policy',
    requiresLatestTermsAccepted: true,
    marketingPrice: 299,
    // HDS: dates from src/data/holidays.json. On by default; set disabled: true to turn off this market.
    holidayHours: {
      useHolidayDataFile: true,
      modalLeadDays: 21,
      profiles: [
        {
          regions: [],
          onlyEditHolidayDays: true,
        },
      ],
    },
  },
  uk: {
    ecCountryCode: 'UK',
    locale: 'en-UK',
    currency: 'GBP',
    currencySymbol: '£',
    centSymbol: 'p',
    minDiscount: 25,
    blockedRoutes: [
      '/oppo/:oppoId',
      '/alloppos/:restId',
      '/booking-confirm/:bookingId',
      '/booking-call/:bookingId',
      '/billing',
      '/menus',
      '/landing-booking',
      '/livebookings',
      '/livebookings/runsheet',
      '/livebookings/floorplan',
      '/livebookings/floorplan/edit',
      '/livebookings/timeline',
      '/livebookings/monthly',
      '/livebookings/guestbook',
      '/livebookings/voucher-redemptions',
      '/livebookings/settings',
      '/livebookings/integrations',
      '/livebookings/integrations/fbmarketplace',
      '/goals/previous',
      '/goals/create',
      '/goals/edit/:goalId',
      '/goals/:goalId',
      '/guest-manager',
      '/segmentation-tags',
    ],
    whiteLabelBlocked: true,
    opposBlocked: true,
    goalsBlocked: true,
    takeawayBlocked: true,
    loyaltyBlocked: false,
    partnerFaqUrl: 'https://eatclub.co.uk/partners/faqs',
    supportPhone: '07441 915 597',
    supportEmail: 'hello@eatclub.co.uk',
    supportEmail2: 'hello@eatclub.co.uk', // Same as supportEmail1 for UK
    trialSupportEmail: 'forecasting.support@eatclub.com.au', // TODO: replace with UK-specific email once UK is live
    settlementGuide: 'https://eccdn.com.au/partnerportal/Settlement%20guide%20UK.pdf',
    welcomeGuide: 'https://eccdn.com.au/partnerportal/Welcome%20Guide%20UK.pdf',
    paymentProvider: 'airwallex',
    eftposName: 'card machine',
    taxCode: 'VAT',
    taxIdentifierLabel: 'VAT',
    publicImagePath: 'https://eccdn.com.au/partnerportal/img/gb',
    customerTermsUrl: 'https://eatclub.co.uk/terms',
    privacyPolicyUrl: 'https://eatclub.co.uk/privacy-policy',
    requiresLatestTermsAccepted: true,
    marketingPrice: 299,
    holidayHours: {
      useHolidayDataFile: true,
      modalLeadDays: 21,
      profiles: [
        {
          regions: [],
          onlyEditHolidayDays: true,
        },
      ],
    },
  },
  nz: {
    ecCountryCode: 'NZ',
    locale: 'en-NZ',
    currency: 'NZD',
    currencySymbol: '$',
    centSymbol: '¢',
    minDiscount: 25, // TODO: confirm NZ minimum discount
    // NZ launches restricted, mirroring the UK feature set.
    blockedRoutes: [
      '/oppo/:oppoId',
      '/alloppos/:restId',
      '/booking-confirm/:bookingId',
      '/booking-call/:bookingId',
      '/billing',
      '/menus',
      '/landing-booking',
      '/livebookings',
      '/livebookings/runsheet',
      '/livebookings/floorplan',
      '/livebookings/floorplan/edit',
      '/livebookings/timeline',
      '/livebookings/monthly',
      '/livebookings/guestbook',
      '/livebookings/voucher-redemptions',
      '/livebookings/settings',
      '/livebookings/integrations',
      '/livebookings/integrations/fbmarketplace',
      '/goals/previous',
      '/goals/create',
      '/goals/edit/:goalId',
      '/goals/:goalId',
      '/guest-manager',
      '/segmentation-tags',
    ],
    whiteLabelBlocked: true,
    opposBlocked: true,
    goalsBlocked: true,
    takeawayBlocked: true,
    loyaltyBlocked: true,
    partnerFaqUrl: 'https://eatclub.co.nz/partners/faqs', // TODO: confirm NZ FAQ URL
    supportPhone: '', // TODO: NZ support phone
    supportEmail: 'hello@eatclub.co.nz', // TODO: confirm NZ support email
    supportEmail2: 'hello@eatclub.co.nz', // TODO: confirm NZ support email
    trialSupportEmail: 'forecasting.support@eatclub.com.au', // TODO: replace with NZ-specific email once NZ is live
    settlementGuide: 'https://eccdn.com.au/partnerportal/Settlement%20guide%20NZ.pdf', // TODO: confirm NZ settlement guide
    welcomeGuide: 'https://eccdn.com.au/partnerportal/Welcome%20Guide%20NZ.pdf', // TODO: confirm NZ welcome guide
    paymentProvider: 'vgs',
    eftposName: 'EFTPOS', // TODO: confirm NZ EFTPOS terminology
    taxCode: 'GST',
    taxIdentifierLabel: 'NZBN',
    publicImagePath: 'https://eccdn.com.au/partnerportal/img/nz', // TODO: confirm NZ image path
    customerTermsUrl: 'https://eatclub.co.nz/terms', // TODO: confirm NZ terms URL
    privacyPolicyUrl: 'https://eatclub.co.nz/privacy-policy', // TODO: confirm NZ privacy URL
    requiresLatestTermsAccepted: false, // TODO: confirm for NZ
    marketingPrice: 299, // TODO: confirm NZ marketing price
    holidayHours: {
      useHolidayDataFile: true,
      modalLeadDays: 21,
      profiles: [
        {
          regions: [],
          onlyEditHolidayDays: true,
        },
      ],
    },
  },
};

['au', 'uk', 'nz'].forEach((loc) => {
  assertHolidayProfilesConfig(localeConfigs[loc].holidayHours, loc);
});

/**
 * Get the config for the locale
 * Allows providing a locale as parameter, otherwise uses the env's locale
 * @param locale
 * @returns {*|{ecCountryCode: string, locale: string, currency: string, minDiscount: number, blockedRoutes: [], whiteLabelBlocked: boolean, opposBlocked: boolean, goalsBlocked: boolean, takeawayBlocked: boolean, partnerFaqUrl: string, supportPhone: string, supportEmail: string, settlementGuide: string}}
 */
export const getAppConfig = (locale = null) =>
  localeConfigs?.[locale] ?? localeConfigs[import.meta.env.VITE_LOCALE] ?? localeConfigs.au;

/**
 * Maps a restaurant's country code to a locale config key.
 * Keep this the single source of truth for country -> locale mapping so new
 * markets can't silently fall back to another locale's config.
 */
export const COUNTRY_CODE_TO_LOCALE = {
  AU: 'au',
  UK: 'uk',
  NZ: 'nz',
};

/**
 * Get the locale for the restaurant. This comes from the country code
 * @param restaurant
 * @returns {string}
 */
export const getRestaurantLocale = (restaurant) => {
  const countryCode = restaurant?.countryCode;

  // Fall back to env if restaurant has no country
  if (countryCode === null || countryCode === undefined || countryCode === '') {
    return import.meta.env.VITE_LOCALE;
  }

  return COUNTRY_CODE_TO_LOCALE[countryCode.toUpperCase()] ?? 'au';
};

// TODO replace most getAppConfig calls with this so that we can view stats in the specific restaurant's locale
export const getRestaurantConfig = (restaurant) => {
  return getAppConfig(getRestaurantLocale(restaurant));
};
